import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface candidatesForRemove {
    candidatesForRemove: number[]
}

const initialState: candidatesForRemove = {
    candidatesForRemove: [],
}

const licenseSlice = createSlice({
    initialState,
    name: "licenses",
    reducers: {
        addCandidate(state, action) {
            const idLicense = action.payload.id;
            state.candidatesForRemove.push(action.payload.id)

            if (!state.candidatesForRemove.includes(idLicense)) {
                state.candidatesForRemove.push(idLicense);
            }
        },

        removeCandidate(state, action) {
            const idLicense = action.payload;
            state.candidatesForRemove = state.candidatesForRemove.filter(candidate => candidate !== idLicense);
        },

        addAllCandidates(state, action: PayloadAction<(number | undefined)[]>) {
            const listID = action.payload ?? [];

            listID.forEach((candidate) => {
                if (candidate && !state.candidatesForRemove.includes(candidate)) {
                    state.candidatesForRemove.push(candidate)
                }
            })
        },

        removeAllCandidates(state) {
            state.candidatesForRemove = [];
        }
    }
})

export const licenseSliceActions = licenseSlice.actions;

export default licenseSlice;